
import { useRef, useState } from "react";

export const useCountdownTimer = (initialTime: number) => {
  const [timer, setTimer] = useState<number>(initialTime);
  const [isTimerRunning, setIsTimerRunning] = useState<boolean>(false);

  const intervalRef = useRef<NodeJS.Timeout | null>(null);

  const startTimer = () => {
    if (isTimerRunning || intervalRef.current) return;

    setIsTimerRunning(true);

    intervalRef.current = setInterval(() => {
      setTimer((prevTimer) => {
        if (prevTimer <= 1) {
          clearInterval(intervalRef.current!);
          intervalRef.current = null;
          setIsTimerRunning(false);
          return 0;
        }
        return prevTimer - 1;
      });
    }, 1000);
  };

  const stopTimer = () => {
    setIsTimerRunning(false);
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }
    setTimer(0);
  };

  // ⬅⬅⬅ UPDATED: Accept a custom time
  const resetTimer = (newTime: number = initialTime) => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }
    setTimer(newTime);
    setIsTimerRunning(false);
  };

  return { timer, isTimerRunning, startTimer, stopTimer, resetTimer };
};

